import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';

const InPageFeaturesV5Container = styled(SectionLayout)`
  &.toggle {
    .section-layout--inner-container {
      padding-top: 40px;
    }
  }

  .navigation-item-container {
    img {
      image-rendering: unset;
    }
  }

  .featured-content-wrapper.reversed {
    flex-direction: row-reverse;
  }

  .navigation-items-container,
  .featured-content-container {
    display: flex;
    align-items: center;
  }

  .website-image,
  .gatsby-image-wrapper {
    max-height: 275px;
    max-width: 315px;
    height: auto;
    width: auto;
  }

  @media (max-width: 767px) {
    .navigation-item-container {
      margin-bottom: 0;
    }

    .website-image {
      box-shadow: none;
      height: auto;
      width: 100%;
      max-width: 100%;
    }

    .gatsby-image-wrapper {
      width: auto;
      height: auto;
      max-height: 275px;

      img {
        object-fit: contain;
        width: 100%;
        height: auto;
        max-width: 315px;
        max-height: 275px;
        opacity: 1;
      }
    }

    .navigation-items-row {
      row-gap: 10px !important;
    }
  }
`;

export { InPageFeaturesV5Container };
